<template lang="pug">
    .settings-profile
        settings-page-head
        .settings-profile-wrapper
            .profile-upload-images-wrapper
                drag-and-drop-image-upload(ref="coverImage" :intialImage="user.cover_image" recommendedSizeText="1400 x 280 (5 : 1)")
                .profile-image-upload
                    input.profile-image-input(type="file" accept="image/*" @change="addFileProfile" ref="profileImageInput")
                    label(:class="{ 'profile-image-border': profileImage !== null }" :style="profileImageThumb" @click="changeUserPhoto")
                        svg-icon(iconId="plus" v-if="!profileImageAvailable")
                    settings-image-actions.user-profile-image(v-if="profileImageAvailable" @deletePhoto="deleteUserPhoto" @changePhoto="changeUserPhoto")

            .profile-details
                head-of-settings-section(title="Profile Details")
                .settings__form-wrapper
                    .left-form-section
                        .re-inp-box
                            re-input(label="Username" v-model.trim="$v.fields.username.$model" :validations="validations.username" :v="$v.fields.username" @input="$v.fields.username.$reset")
                        .re-inp-box.textarea-wrap
                            re-textarea.three-lines(label="About" v-model.trim="fields.about")
                    .right-form-section
                        .re-inp-box
                            re-input(label="Display Name" v-model.trim="$v.fields.name.$model" :validations="validations.name" :v="$v.fields.name" @input="$v.fields.name.$reset")
                        .re-inp-box
                            re-select(label="Country" v-model="fields.country")
                                option(value="")
                                option(v-for="country in countries" :value="country.code") {{ country.name }}
                        .re-inp-box
                            re-input(label="Location" v-model.trim="fields.location")
                        .re-inp-box
                            re-input(label="Website URL" v-model.trim="fields.website_url")

                .settings-profile__followers-display
                    .settings-profile__followers-display-wrap
                        span.settings-profile__followers-display-title Enable Followers Count visibility
                        span.settings-profile__followers-display-subtitle Show Followers Count on Creator page
                    settings-switcher(v-model="fields.followers_count_display")
                
                .settings-profile__followers-display(v-if="fields.followers_count_display")
                    .settings-profile__followers-display-wrap
                        span.settings-profile__followers-display-title Enable Followers visibility
                        span.settings-profile__followers-display-subtitle Show Followers list on Creator page
                    settings-switcher(v-model="fields.followers_display")


            .porfile-subscription(v-if="user.creator")
                head-of-settings-section(title="Subscription")
                .subscription-form-wrapper(v-for="(subscription, subscriptionIndex) in fields.subscriptions")
                    .settings__form-wrapper
                        .left-form-section
                            .re-inp-box
                                re-input(
                                    label="Subscription Title"
                                    v-model.trim="$v.fields.subscriptions.$model[subscriptionIndex].title"
                                    :validations="validations.subscriptions.$each.title"
                                    :v="$v.fields.subscriptions.$each[subscriptionIndex].title"
                                    @input="$v.fields.subscriptions.$each[subscriptionIndex].title.$reset"
                                )
                        .right-form-section
                            re-button.re-button--primary.re-button--circle.profile-remove-subscription(@click="deleteSubscription(subscriptionIndex)")
                                svg-icon(iconId="trash-can")
                    .settings__form-wrapper(v-for="(plan, planIndex) in subscription.plans")
                        .left-form-section
                            .settings__form-wrapper
                                .left-form-section
                                    .re-inp-box
                                        re-input(
                                            label="Plan Title"
                                            v-model.trim="$v.fields.subscriptions.$model[subscriptionIndex].plans[planIndex].title"
                                            :validations="validations.subscriptions.$each.plans.$each.title"
                                            :v="$v.fields.subscriptions.$each[subscriptionIndex].plans.$each[planIndex].title"
                                            @input="$v.fields.subscriptions.$each[subscriptionIndex].plans.$each[planIndex].title.$reset"
                                        )
                                    .re-inp-box
                                        re-input(
                                            label="Bill Every"
                                            v-model.trim="plan.period"
                                            :validations="validations.subscriptions.$each.plans.$each.period"
                                            :v="$v.fields.subscriptions.$each[subscriptionIndex].plans.$each[planIndex].period"
                                            @input="$v.fields.subscriptions.$each[subscriptionIndex].plans.$each[planIndex].period.$reset"
                                             :disabled="plan.exists"
                                             :readonly="plan.exists"
                                             min="1"
                                             step="1"
                                             type="number"
                                        )
                                .right-form-section
                                    .re-inp-box
                                        re-input(
                                            label="Price"
                                            v-model.trim="$v.fields.subscriptions.$model[subscriptionIndex].plans[planIndex].amount"
                                            :validations="validations.subscriptions.$each.plans.$each.amount"
                                            :v="$v.fields.subscriptions.$each[subscriptionIndex].plans.$each[planIndex].amount"
                                            @input="$v.fields.subscriptions.$each[subscriptionIndex].plans.$each[planIndex].amount.$reset"
                                             :disabled="plan.exists"
                                             :readonly="plan.exists"
                                             min="0.01"
                                             step="0.01"
                                             type="number"
                                        )
                                    .re-inp-box.plan-interval
                                        select-field(label="." v-model.trim="plan.interval" :options="planIntervalOptions" :disabled="plan.exists" :readonly="plan.exists")

                        .right-form-section
                            .re-inp-box.textarea-wrap
                                re-textarea.two-lines(name="description" label="Description" v-model.trim="plan.description")
                    .profile-add-subscription.plan
                        button.profile-add-subscription__button(@click="addSubscriptionPlan(subscription)")
                            svg-icon(iconId="plus")
                        span Add Plan
                .profile-add-subscription
                    button.profile-add-subscription__button(@click="addSubscription")
                        svg-icon(iconId="plus")
                    span Add Subscription

            .profile-links
                head-of-settings-section(title="Links to Accounts")
                .settings__form-wrapper
                    .left-form-section
                        .re-inp-box
                            re-input(label="Instagram" v-model.trim="fields.instagram")
                        .re-inp-box
                            re-input(label="TikTok" v-model.trim="fields.tiktok")
                    .right-form-section
                        .re-inp-box
                            re-input(label="Twitter" v-model.trim="fields.twitter")
                        .re-inp-box
                            re-input(label="Snapchat" v-model.trim="fields.snapchat")

            re-toast-alert(v-if="errorMessageProfile" type="danger") {{ errorMessageProfile }}

            .settings-save-button
                re-button.re-button--primary.re-button--sm(@click="submit" :loading="formSubmitting")

</template>

<script>
import ReProfileEdit from 'utils/vue/components/complex/profile/re-profile-edit/script.js'
import { Validators, parseValidations, setValidationRule, parseValidationSetup } from 'utils/vue/lib/validations'
import UploadedFileUtils from '../../lib/uploaded-file-utils'
import UserProductsService from '../../services/user-products-service'
import { countries } from 'utils/vue/lib/utils'

const VALIDATIONS = {
    username: setValidationRule('fields.username', {
        required: { error: 'Username is required' }
    }),
    name: setValidationRule('fields.name', {
        required: { error: 'Display name is required' }
    }),
    subscriptions: {
        $each: {
            title: {
                required: Validators.required,
            },
            plans: {
                $each: {
                    title: {
                        required: Validators.required,
                    },
                    amount: {
                        required: Validators.required,
                        minValue: Validators.minValue(0.01),
                        numeric: Validators.numeric,
                    },
                    period: {
                        required: Validators.required,
                        minValue: Validators.minValue(1),
                        integer: Validators.integer,
                    },
                },
            },
        },
    }
}

export default {
    name: 'gmh-profile-edit',

    mixins: [
        ReProfileEdit
    ],

    data() {
        return {
            fields: {
                username: '',
                name: '',
                country: '',
                country_name: '',
                location: '',
                website_url: '',
                about: '',
                followers_count_display: false,
                followers_display: false,
                instagram: '',
                tiktok: '',
                twitter: '',
                snapchat: '',
                subscriptions: [],
            },

            countries: countries.sort((a, b) => (a.name > b.name ? 1 : -1)),

            profileImage: null,
            profileImageRemoved: false,
        }
    },

    validations() {
        const fields = parseValidations(VALIDATIONS)
        return {
            fields: {
                ...fields,
                subscriptions: VALIDATIONS.subscriptions,
            }
        }
    },

    computed: {
        profileImageThumb() {
            let url = null

            if (this.profileImage) {
                url = URL.createObjectURL(this.profileImage)
            } else if (!this.profileImageRemoved) {
                url = this.user.profile_image
            }

            return url ?
                { 'background-image': "url(" + url + ")" } :
                { "background-color": "#F3F3F3" }
        },
        profileImageAvailable() {
            return this.profileImage || (!this.profileImageRemoved && this.user.profile_image)
        },
        planIntervalOptions() {
            return [
                {  value: 'day', name: 'Day' },
                {  value: 'week', name: 'Week' },
                {  value: 'month', name: 'Month' },
                {  value: 'year', name: 'Year' },
            ]
        },
    },

    watch: {
        'fields.country'(country) {
            this.fields.country_name = this.countries.find(x => x.code == country)?.name || ''
        },
        'fields.followers_count_display'(v) {
            if (!v) {
                this.fields.followers_display = false
            }
        },
    },

    created() {
        if (this.user.creator) {
            this.loadSubscriptions()
        }
    },

    methods: {
        setupFormLocal() {
            this.validations = parseValidationSetup(VALIDATIONS, this)
            this.setupForm(VALIDATIONS, { username: '', name: '', subscriptions: [] })
        },

        hydrateFields(fields) {
            const values = {
                ..._.pick(this.user, ['username', 'name']),
                ..._.pick(this.user.meta, ['location', 'website_url', 'about', 'followers_count_display', 'followers_display', 'instagram', 'tiktok', 'twitter', 'snapchat', 'country', 'country_name']),
            }

            _.forOwn(this.fields, (item, key) => {
                if (!_.isNil(values[key])) {
                    this.fields[key] = values[key]
                }
            })
        },

        async submit() {
            const payload = {
                username: this.fields.username,
                name: this.fields.name,
                country: this.fields.country,
                country_name: this.fields.country_name,
                location: this.fields.location,
                website_url: this.fields.website_url,
                about: this.fields.about,
                followers_count_display: this.fields.followers_count_display,
                followers_display: this.fields.followers_display,

                instagram: this.fields.instagram,
                tiktok: this.fields.tiktok,
                twitter: this.fields.twitter,
                snapchat: this.fields.snapchat,
            }

            if (this.user.creator) {
                payload.subscriptions = this.fields.subscriptions
            }

            if (this.profileImage || this.profileImageRemoved) {
                payload.profile_image = await UploadedFileUtils.getFileBase64(this.profileImage)
            }
            if (this.$refs.coverImage.bgFile || this.$refs.coverImage.initialImageRemoved) {
                payload.cover_image = await UploadedFileUtils.getFileBase64(this.$refs.coverImage.bgFile)
            }

            this.isSuccessPersonal = null
            this.$v.$touch()
            if (await this.changeProfile(payload)) {
                this.isSuccessPersonal = true

                this.$parent.$parent.$refs.scrollElement.scrollTo({ top: 0, behavior: 'smooth' })

                if (this.user.creator) {
                    await this.loadSubscriptions()
                }
            }
        },

        addFileProfile(e) {
            const droppedFile = e.target.files[0]
            if (droppedFile) {
                this.profileImage = droppedFile
            }
            e.target.value = ''
            
        },
        deleteUserPhoto() {
            if (this.profileImage) {
                this.profileImage = null
            } else {
                this.profileImageRemoved = true
            }
        },
        changeUserPhoto() {
            this.$refs.profileImageInput.click()
        },

        addSubscription() {
            const subscription = {
                title: null,
                plans: [],
            }

            this.addSubscriptionPlan(subscription)

            this.fields.subscriptions.push(subscription)
        },
        deleteSubscription(index) {
            this.fields.subscriptions.splice(index, 1);
        },
        addSubscriptionPlan(subscription) {
            subscription.plans.push({
                title: null,
                description: null,
                amount: 0,
                period: 1,
                interval: 'month',
            })
        },

        async loadSubscriptions() {
            const products = await UserProductsService.byType(this.user.id, 'subscription')

            this.fields.subscriptions = products
                .map(product => ({
                    id: product.id,
                    title: product.title,
                    plans: product.plans.data
                        .filter(plan => plan.is_active)
                        .map(plan => ({
                            id: plan.id,
                            title: plan.display_name,
                            description: plan.description,
                            amount: plan.amount,
                            period: plan.period,
                            interval: plan.interval,
                            exists: !!plan.id,
                        }))
                }))
        }
    }
}
</script>
